// Author lidongxu
// Date 2024-01-16 15:13:20

import * as model from "@/model/sithMes/inventory/SithMesInventoryComprehensiveBusinessVendorAndSithInfoModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesInventoryComprehensiveBusinessVendorAndSithInfo(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_INVENTORY_URL,
    })
    .buildStore()
